import Request from '../../../../src/core/gd/data/request'

export default class PinsApi {

    static addPin(data: {
        projectId?      : string,
        taskId?         : string,
        userId?         : string,
        organizationId? : string,
        customViewId?   : string,
        documentId?     : string,
    }) {
        return new Request(this,'POST','pins',{
            projectId   : data.projectId,
            taskId      : data.taskId,
            userId      : data.userId,
            companyId   : data.organizationId,
            customViewId: data.customViewId,
            documentId  : data.documentId
        })
    }

    static removePin(id: string) {
        return new Request(this,'DELETE','pin/'+id)
    }
}